import { m as motion } from "framer-motion";
import { MembershipTiersSection } from "@/components/membership-tiers-section";
import { CallToActionSection } from "@/components/call-to-action-section";
import {
  EARLY_BIRD_DISCOUNT_CODE,
  EARLY_BIRD_DISCOUNT_LABEL,
} from "@/lib/cohorts";
import { useSEO } from "@/lib/use-seo";
import { breadcrumb } from "@/lib/seo-schemas";

const Membership = () => {
  useSEO({
    title: "Membership Tiers & Pricing",
    description: "Compare Free, Standard ($30/mo), and Premium ($1,400 lifetime) membership tiers. Includes live cohorts, AI chat platform, custom agents, and 200-member community.",
    path: "/membership",
    ogImage: "/images/og-membership.jpg",
    jsonLd: breadcrumb([
      { name: "Home", path: "/" },
      { name: "Membership", path: "/membership" },
    ]),
  });
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-mesh pt-36 md:pt-32 pb-8">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-96 h-96 bg-gradient-radial-primary opacity-30 blur-3xl" />
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-gradient-radial-secondary opacity-30 blur-3xl" />
        </div>
        <div className="section-inner relative z-10 text-center space-y-5">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold"
          >
            Choose Your{" "}
            <span className="bg-gradient-to-r from-[hsl(var(--primary))] via-[hsl(var(--secondary))] to-[hsl(var(--accent))] bg-clip-text text-transparent">
              Membership
            </span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="text-lg md:text-xl text-foreground/80 max-w-2xl mx-auto"
          >
            From free community access to premium live cohorts — pick the level
            that matches your learning style and career goals.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.25 }}
            className="inline-flex flex-wrap items-center justify-center gap-2 rounded-full bg-secondary/10 px-4 py-2 text-sm font-semibold text-secondary"
          >
            <span>{EARLY_BIRD_DISCOUNT_LABEL}</span>
            <span className="rounded-md bg-background px-2 py-0.5 font-bold text-foreground">
              {EARLY_BIRD_DISCOUNT_CODE}
            </span>
          </motion.p>
        </div>
      </section>

      {/* Pricing Tiers */}
      <MembershipTiersSection />

      {/* CTA */}
      <CallToActionSection />
    </div>
  );
};

export default Membership;
